module.exports = __webpack_public_path__ + "img/6.aef961a7.jpg";